export type CompareFn<T> = (item1: T, item2: T) => number;

export function stringComparator<T>(key: (item: T) => string): CompareFn<T> {
  return (item1, item2) => key(item1).localeCompare(key(item2));
}

export function numberComparator<T>(key: (item: T) => number): CompareFn<T> {
  return (item1, item2) => key(item1) - key(item2);
}

export function dateComparator<T>(key: (item: T) => Date): CompareFn<T> {
  return (item1, item2) => key(item1).getTime() - key(item2).getTime();
}

export function descComparator<T>(comparator: CompareFn<T>): CompareFn<T> {
  return (item1, item2) => -comparator(item1, item2);
}

export function ascDescComparator<T>(
  comparator: CompareFn<T>,
  { isDescending }: { isDescending: boolean },
): CompareFn<T> {
  return isDescending ? descComparator(comparator) : comparator;
}
